/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown>, time: NonNullable<unknown> }} Onboarding_ProgressInputs */

const en_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.current} of ${i?.total} · ~${i?.time}`)
};

const de_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schritt ${i?.current} von ${i?.total} · ~${i?.time}`)
};

const fr_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Étape ${i?.current} sur ${i?.total} · ~${i?.time}`)
};

const es_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paso ${i?.current} de ${i?.total} · ~${i?.time}`)
};

const it_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passo ${i?.current} di ${i?.total} · ~${i?.time}`)
};

const nl_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stap ${i?.current} van ${i?.total} · ~${i?.time}`)
};

const pl_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Krok ${i?.current} z ${i?.total} · ~${i?.time}`)
};

const fi_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Askel ${i?.current} / ${i?.total} · ~${i?.time}`)
};

const da_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trin ${i?.current} af ${i?.total} · ~${i?.time}`)
};

const sv_onboarding_progress = /** @type {(inputs: Onboarding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Steg ${i?.current} av ${i?.total} · ~${i?.time}`)
};

/**
* | output |
* | --- |
* | "Step {current} of {total} · ~{time}" |
*
* @param {Onboarding_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_progress = /** @type {((inputs: Onboarding_ProgressInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_ProgressInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_progress(inputs)
	if (locale === "fr") return fr_onboarding_progress(inputs)
	if (locale === "es") return es_onboarding_progress(inputs)
	if (locale === "it") return it_onboarding_progress(inputs)
	if (locale === "nl") return nl_onboarding_progress(inputs)
	if (locale === "pl") return pl_onboarding_progress(inputs)
	if (locale === "fi") return fi_onboarding_progress(inputs)
	if (locale === "da") return da_onboarding_progress(inputs)
	if (locale === "sv") return sv_onboarding_progress(inputs)
	return en_onboarding_progress(inputs)
});